<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Footer from '@components/footer'
import { authComputed } from '@state/helpers'
import Appmenu from './app-menu'
import axios from 'axios'
import appConfig from '@src/app.config'
import { mapGetters } from 'vuex'
const apiDomain = appConfig.apiDomain

/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  components: { VuePerfectScrollbar, Appmenu, Footer },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    width: { type: String, required: true },
    user: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      showmodal: false,
      createModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('auth', ['isAdmin']),
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('auth', ['isSubAccount']),
  },

  watch: {
    theme: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'dark':
            document.body.classList.add('left-side-menu-dark')
            document.body.classList.remove('left-side-menu-condensed')
            document.body.classList.remove('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-dark')
            break
        }
      }
    },
    type: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'condensed':
            document.body.classList.add('left-side-menu-condensed')
            document.body.classList.remove('left-side-menu-dark')
            document.body.classList.remove('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-condensed')
            break
        }
      }
    },
    width: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'boxed':
            document.body.classList.add('left-side-menu-condensed')
            document.body.classList.remove('left-side-menu-dark')
            document.body.classList.add('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-condensed')
            document.body.classList.remove('boxed-layout')
            break
        }
      }
    },
  },
  methods: {
    hideModal(e) {
      this.submitted = false
      this.showmodal = false
    },
    handleSubmit(e) {
      this.submitted = true
      // stop here if form is invalid
      this.event = {}

      const formData = new FormData()
      formData.append('current_password', this.currentPassword)
      formData.append('newPassword', this.newPassword)
      formData.append('confirm', this.newPasswordConfirm)
      axios
        .post(apiDomain + 'reset-password', formData)
        .then((response) => {
          if (response.data.status === 'success') {
            this.hideModal()
            this.$toastr.s('Change password success', 'Change Password')
          } else {
            var message = 'Change password error'
            if (response.data.message) message = response.data.message

            this.$toastr.e(message, 'Change Password')
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // commit('SET_CURRENT_USER', null)
          }
          this.$toastr.e('Change password error', 'Change Password')
          return null
        })
    },
    showProfile() {
      this.$router.push({ path: '/account/profile' })
    },
    requestTopup() {
      this.$router.push({ path: '/billing/topup' })
    },
    userName(user) {
      let username = null
      if (user) {
        username =
          user.first_name && user.last_name
            ? `${user.first_name} ${user.last_name}`
            : user.email
      }
      return username
    },
  },
}
</script>

<template>
  <div class="left-side-menu">
    <b-modal
      v-model="showmodal"
      title="Change Password"
      title-class="text-black font-18"
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Current Password</label>
              <input
                id="name"
                v-model="currentPassword"
                type="password"
                class="form-control"
                placeholder="Enter Current Password"
                :class="{ 'is-invalid': submitted && $v.event.title.$error }"
              />
              <div
                v-if="submitted && !$v.event.title.required"
                class="invalid-feedback"
                >This value is required.</div
              >
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="name">New Password</label>
              <input
                id="name"
                v-model="newPassword"
                type="password"
                class="form-control"
                placeholder="Enter New Password"
                :class="{ 'is-invalid': submitted && $v.event.title.$error }"
              />
              <div
                v-if="submitted && !$v.event.title.required"
                class="invalid-feedback"
                >This value is required.</div
              >
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="name">New Password Confirm</label>
              <input
                id="name"
                v-model="newPasswordConfirm"
                type="password"
                class="form-control"
                placeholder="Enter New Password Confirm"
                :class="{ 'is-invalid': submitted && $v.event.title.$error }"
              />
              <div
                v-if="submitted && !$v.event.title.required"
                class="invalid-feedback"
                >This value is required.</div
              >
            </div>
          </div>
        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-success">Save</button>
          <b-button class="ml-1" variant="light" @click="hideModal"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>

    <div class="sidebar-content">
      <VuePerfectScrollbar
        v-if="!isCondensed"
        v-once
        class="slimscroll-menu"
        :settings="settings"
      >
        <div id="sidebar-menu">
          <Appmenu />
        </div>
      </VuePerfectScrollbar>
      <div v-else id="sidebar-menu">
        <Appmenu />
      </div>
    </div>
    <!-- Sidebar -left -->
    <Footer />
  </div>
  <!-- Left Sidebar End -->
</template>

<style lang="scss">
.slimscroll-menu {
  height: 100%;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
</style>
